import { render, staticRenderFns } from "./browse-trending-mixes.vue?vue&type=template&id=2ac3c208"
import script from "./browse-trending-mixes.vue?vue&type=script&setup=true&lang=js"
export * from "./browse-trending-mixes.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports